var map = {
	"./GameLoader.js": 455,
	"./GuessWho/GuessConfirmationModal.js": 397,
	"./GuessWho/GuessWho.js": 131,
	"./GuessWho/GuessWhoBoard.js": 603,
	"./GuessWho/GuessWhoRules.js": 80,
	"./GuessWho/hooks/useGuessWhoGame.js": 291,
	"./ReactionTest.js": 625,
	"components/MiniGames/games/GameLoader.js": 455,
	"components/MiniGames/games/GuessWho/GuessConfirmationModal.js": 397,
	"components/MiniGames/games/GuessWho/GuessWho.js": 131,
	"components/MiniGames/games/GuessWho/GuessWhoBoard.js": 603,
	"components/MiniGames/games/GuessWho/GuessWhoRules.js": 80,
	"components/MiniGames/games/GuessWho/hooks/useGuessWhoGame.js": 291,
	"components/MiniGames/games/ReactionTest.js": 625
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 794;